// extracted by mini-css-extract-plugin
module.exports = {"itemText":"SimpleArrayField_itemText__2EFBh"};